module.exports = "<form class=\"ta-left\" name=\"siteSeoSettings\" ng-submit=\"saveHomePage(currentPage, siteSeoSettings)\"><div class=\"site-settings__bg-wrapper\" site-bg-settings=\"\" ng-model=\"currentPage\"></div><button class=\"button button_green button_extra-small\" ng-disabled=\"savingPage\" type=\"submit\">{{'editor.siteSettings.tabs.item4.saveButton' | translate}}</button></form>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/site/site_settings/settings_views/bg.jade
// module id = 411
// module chunks = 0